<template>
  <div
    id="transaction"
    class="content noscroll draggable-window text-center"
    style="width: 20%;"
  >
    <h1 class="titlebar noright">
      <span>Transaction</span>
    </h1>
    <div class="inner">
      <div id="transaction-inner">
        <span v-if="pending && pendingTxURL">
          Your <a
            :href="pendingTxURL"
            target="_blank"
          >transaction</a> is pending...<br><br>
          Please do not reload or close this page yet!
          <LoadingSpinner />
        </span>
        <span v-else-if="pending && !pendingTxURL">
          Please accept your transaction in Metamask.
          <LoadingSpinner />

        </span>
        <span
          v-else
          v-html="finishedTxString"
        />
      </div>
    </div>
  </div>
</template>

<script>
import LoadingSpinner from '@/components/LoadingSpinner.vue'
import { bringToFront } from '@/windowStack'

export default {
  name: 'TransactionWindow',
  props: {
    pending: Boolean,
    minted: Boolean,
    pendingTxURL: String,
    finishedTxString: String
  },
  components: {
    LoadingSpinner: LoadingSpinner
  },
  mounted () {
    bringToFront(this.$el)
    jQuery(this.$el).draggable({
      handle: 'h1.titlebar',
      containment: jQuery('.desktop'),
      start: (event) => {
        jQuery('#sound_move_stop').trigger('play')
      },
      stop: (event, ui) => {
        jQuery('#sound_move_stop').trigger('play')
      }
    })
  }
}
</script>
